import { useAppDispatch } from 'app/store';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  SystemStyleObject,
} from '@chakra-ui/react';
import { ImageDropzone } from 'app/components/Profile/ProfileImage/ImageDropzone';
import { MIN_ALLOWED_DIMENSION } from 'app/components/Profile/ProfileImage/constants';
import { DropImageModalProps } from 'app/components/Core/UploadImageModal/types';

const closeBtnSx: SystemStyleObject = {
  size: 'xl',
  height: 12,
  width: 12,
  right: 10,
  top: 10,
  bg: 'M.30',
  color: 'textSubdued',
  _hover: {
    color: 'textBase',
  },
  borderRadius: '50%',
  outline: 'none',
};

export const DropImageModal = ({
  setAvatar,
  open,
  onClose,
  minAllowedDimension,
}: DropImageModalProps) => {
  const dispatch = useAppDispatch();
  const minDimension = minAllowedDimension || MIN_ALLOWED_DIMENSION;

  return (
    <Modal isOpen={open!} onClose={onClose!} isCentered size="full">
      <ModalOverlay left="-1px" />
      <ModalContent justifyContent="center" alignItems="center" px={8}>
        <ModalCloseButton data-testid="close-icon" sx={closeBtnSx} />
        <ImageDropzone
          dispatch={dispatch}
          onImageUploaded={setAvatar!}
          secondaryText={`Minimum ${minDimension} pixels square image. Max 10MB.`}
          minDimension={minDimension}
        />
      </ModalContent>
    </Modal>
  );
};
